import getConfig from 'next/config';
import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import styles from './style';
import {
  fetchSimTypes,
  mapApiToInternalSimType,
  mapInternalToApiSimType,
} from './simtypeSelector.util';

const { publicRuntimeConfig } = getConfig();

const HandsetsSimTypeSelector = ({ setSelectedSIMType, cmsData }) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const [selectedTypeApiValue, setSelectedTypeApiValue] = useState(null);
  const [simTypes, setSimTypes] = useState([]);
  useEffect(() => {
    const loadSimTypes = async () => {
      const apiType = await fetchSimTypes(graphql);
      setSimTypes(apiType);
      //  default to ESIM if handset is ESIM only
      // if (equipmentSimTypes === 'ESIM' && apiType.includes('ESIM')) {
      //   const internalValue = mapApiToInternalSimType.ESIM;
      //   const apiValue = mapInternalToApiSimType[internalValue];
      //   setSelectedTypeApiValue(apiValue);
      //   setSelectedSIMType(apiValue);
      // }
    };
    loadSimTypes();
  }, []);
  const handleSelect = async type => {
    const apiValue = mapInternalToApiSimType[type];
    setSelectedTypeApiValue(apiValue);
    setSelectedSIMType(apiValue);
  };
  return (
    <Box sx={styles(theme).handsetContainer}>
      <Typography variant='h6' sx={styles(theme).handsetHeading}>
        {cmsData?.data?.attributes?.Handset_SimSelector?.SimSelectorHeading}
      </Typography>
      <Grid container spacing={2} justifyContent='center' alignItems='stretch'>
        {simTypes.includes('ALL_IN_1') && (
          <Grid item xs={12} sm={6}>
            <Box sx={{ height: '100%' }}>
              <Paper
                variant='outlined'
                sx={{
                  height: '100%',
                  ...styles(theme).option,
                  ...(selectedTypeApiValue === 'ALL_IN_1' ? styles(theme).selected : null),
                  '&:focus-visible': {
                    outline: '3px solid #DD1D78 !important',
                    outlineOffset: '3px !important',
                    borderRadius: '3px',
                    position: 'relative',
                    zIndex: 1,
                  },
                }}
                tabIndex={0}
                onClick={() => handleSelect(mapApiToInternalSimType.ALL_IN_1)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSelect(mapApiToInternalSimType.ALL_IN_1);
                  }
                }}
              >
                <Box sx={styles(theme).optionContent}>
                  <Box sx={styles(theme).buttonIcon}>
                    {selectedTypeApiValue === 'ALL_IN_1' ? (
                      <img
                        src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.Handset_SimSelector?.pSIM?.selectedIcon?.data?.attributes?.url}`}
                        alt=''
                        style={styles(theme).inlineIcon}
                      />
                    ) : (
                      <img
                        src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.Handset_SimSelector?.pSIM?.icon?.data?.attributes?.url}`}
                        alt=''
                        style={styles(theme).inlineIcon}
                      />
                    )}
                  </Box>
                  <Box sx={styles(theme).textContainer}>
                    <Typography
                      variant='subtitle2'
                      sx={{
                        ...styles(theme).buttonTitle,
                        ...(selectedTypeApiValue === 'ALL_IN_1'
                          ? styles(theme).selectedText
                          : null),
                      }}
                    >
                      {cmsData?.data?.attributes?.Handset_SimSelector?.pSIM?.title}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        ...styles(theme).buttonDescription,
                        ...(selectedTypeApiValue === 'ALL_IN_1'
                          ? styles(theme).selectedText
                          : null),
                      }}
                    >
                      {cmsData?.data?.attributes?.Handset_SimSelector?.pSIM?.description}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Grid>
        )}
        {simTypes.includes('ESIM') && (
          <Grid item xs={12} sm={6}>
            <Box sx={{ height: '100%' }}>
              <Paper
                variant='outlined'
                sx={{
                  height: '100%',
                  ...styles(theme).option,
                  ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selected : null),
                  '&:focus-visible': {
                    outline: '3px solid #DD1D78 !important',
                    outlineOffset: '3px !important',
                    borderRadius: '3px',
                    position: 'relative',
                    zIndex: 1,
                  },
                }}
                tabIndex={0}
                onClick={() => handleSelect(mapApiToInternalSimType.ESIM)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSelect(mapApiToInternalSimType.ESIM);
                  }
                }}
              >
                <Box sx={styles(theme).optionContent}>
                  <Box sx={styles(theme).buttonIcon}>
                    {selectedTypeApiValue === 'ESIM' ? (
                      <img
                        src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.Handset_SimSelector?.eSIM?.selectedIcon?.data?.attributes?.url}`}
                        alt=''
                        style={styles(theme).inlineIcon}
                      />
                    ) : (
                      <img
                        src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.Handset_SimSelector?.eSIM?.icon?.data?.attributes?.url}`}
                        alt=''
                        style={styles(theme).inlineIcon}
                      />
                    )}
                  </Box>
                  <Box sx={styles(theme).textContainer}>
                    <Typography
                      variant='subtitle2'
                      sx={{
                        ...styles(theme).buttonTitle,
                        ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selectedText : null),
                      }}
                    >
                      {cmsData?.data?.attributes?.Handset_SimSelector?.eSIM?.title}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        ...styles(theme).buttonDescription,
                        ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selectedText : null),
                      }}
                    >
                      {cmsData?.data?.attributes?.Handset_SimSelector?.eSIM?.description}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default HandsetsSimTypeSelector;
